<ng-container
  *ngTemplateOutlet="mobileDevice ? mobileTemplate : desktopTemplate "
>
</ng-container>

<ng-template #desktopTemplate>
  <div [ngClass]="{'line-separator--light-grey': isLastShipment}" class="pb-3">
    <div
      class="purchase-options__address delivery--input"
      #divContainer
      *ngIf="delivery && product"
      [ngClass]="{'decision-point' : order.isDecisionPoint, 'list-item': viewType === 'list-item'}"
    >
      <div
        class="purchase-options__address--input pt-0"
        [ngClass]="qtyContainerCSS"
        *ngIf="!product.hasVariations"
      >
        <div class="full-width">
          <input
            *ngIf="!product.isCustomizable"
            class="m-0"
            (change)="onQuantityChanged($event)"
            (blur)="onQuantityBlur()"
            min="0"
            digitOnly
            type="number"
            [value]="delivery.quantity"
            [disabled]="!canPurchase || delivery.is_uneligible"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileTemplate>
  <div>
    <div
      class="purchase-options__address delivery--input"
      *ngIf="delivery && product"
      [ngClass]="{'decision-point' : order.isDecisionPoint, 'list-item': viewType === 'list-item', 'line-separator--light-grey': isLastShipment}"
    >
      <div
        class="purchase-options__address--input shipment--input"
        [ngClass]="{'list-item': viewType === 'list-item'}"
        *ngIf="!product.hasVariations"
      >
        <div class="d-block">
          <input
            *ngIf="!product.isCustomizable"
            class="mb-0"
            (change)="onQuantityChanged($event)"
            (blur)="onQuantityBlur()"
            min="0"
            digitOnly
            type="number"
            [value]="delivery.quantity"
            [disabled]="!canPurchase || delivery.is_uneligible"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>
